import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { useNamedContainers } from '@alfa-bank/site-named-container/utils';

import type { TCpasPageHistorySave, ICpasPageHistorySaveDeps } from './models';
import { CpasPageHistorySave as Component } from './component';

export const CpasPageHistorySave = createWidget<ICpasPageHistorySaveDeps, TCpasPageHistorySave>({
    useNamedContainers,
})(Component);
